function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "71b97fd5d0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "525a882829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 187.5 37.5 C 104.65625 37.5 37.5 104.65625 37.5 187.5 C 37.5 270.34375 104.65625 337.5 187.5 337.5 C 270.34375 337.5 337.5 270.34375 337.5 187.5 C 337.5 104.65625 270.34375 37.5 187.5 37.5 Z M 187.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "834ff626f4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 141.328125 145 L 233.578125 145 L 233.578125 242 L 141.328125 242 Z M 141.328125 145 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "235793c874"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 153 135.53125 L 222 135.53125 L 222 185 L 153 185 Z M 153 135.53125 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#71b97fd5d0)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#525a882829)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  transform: "matrix(0.75, 0, 0, 0.75, 37.500002, 37.499998)",
  fill: "none",
  strokeLinejoin: "miter",
  d: "M 200.00001 0.00000328333 C 89.54167 0.00000328333 -0.00000271667 89.541676 -0.00000271667 200.000016 C -0.00000271667 310.458357 89.54167 400.00003 200.00001 400.00003 C 310.458351 400.00003 400.000024 310.458357 400.000024 200.000016 C 400.000024 89.541676 310.458351 0.00000328333 200.00001 0.00000328333 Z M 200.00001 0.00000328333 ",
  stroke: "#ffffff",
  strokeWidth: 36,
  strokeOpacity: 1,
  strokeMiterlimit: 4
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#834ff626f4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 233.367188 233.140625 C 232.367188 214.171875 215.316406 206.324219 215.316406 206.324219 C 211.246094 204.417969 203.859375 200.691406 199.019531 198.226562 C 205.222656 191.4375 207.054688 180.375 207.339844 178.800781 C 208.632812 171.675781 207.980469 162.855469 207.980469 162.855469 C 206.796875 145.710938 189.484375 145.441406 187.671875 145.457031 C 187.574219 145.457031 187.507812 145.457031 187.507812 145.457031 C 187.507812 145.457031 187.453125 145.457031 187.371094 145.457031 C 185.726562 145.4375 168.222656 145.609375 167.03125 162.855469 C 167.03125 162.855469 166.382812 171.671875 167.675781 178.800781 C 167.757812 179.257812 167.980469 180.535156 168.394531 182.265625 C 171.65625 186.546875 176.691406 188.644531 180.824219 189.671875 C 181.34375 189.167969 182.050781 188.855469 182.835938 188.855469 L 190.367188 188.855469 C 191.960938 188.855469 193.25 190.144531 193.25 191.738281 C 193.25 193.332031 191.960938 194.625 190.367188 194.625 L 182.835938 194.625 C 181.644531 194.625 180.628906 193.910156 180.183594 192.886719 C 177.101562 192.136719 173.535156 190.832031 170.355469 188.585938 C 171.625 191.882812 173.433594 195.417969 176 198.226562 C 171.15625 200.691406 163.777344 204.417969 159.699219 206.324219 C 159.699219 206.324219 142.652344 214.171875 141.652344 233.140625 C 141.652344 233.140625 141.355469 236.292969 147.332031 237.488281 C 147.332031 237.488281 165.648438 241.667969 187.511719 241.667969 C 209.375 241.667969 227.6875 237.488281 227.6875 237.488281 C 233.664062 236.292969 233.367188 233.140625 233.367188 233.140625 Z M 233.367188 233.140625 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#235793c874)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 161.171875 184.949219 L 162.992188 184.949219 L 162.992188 163.578125 C 162.996094 163.523438 163.011719 163.472656 163.011719 163.417969 L 163.011719 160.265625 C 163.011719 154.640625 164.746094 150.078125 168.171875 146.710938 C 175.253906 139.742188 187.355469 139.835938 187.558594 139.863281 C 187.703125 139.851562 199.703125 139.679688 206.816406 146.644531 C 210.265625 150.019531 212.015625 154.601562 212.015625 160.265625 L 212.015625 163.601562 C 212.015625 163.632812 212.023438 163.664062 212.023438 163.695312 L 212.023438 184.949219 L 213.84375 184.949219 C 218.320312 184.949219 221.949219 181.320312 221.949219 176.84375 L 221.949219 169.050781 C 221.949219 165.449219 219.597656 162.402344 216.347656 161.34375 L 216.347656 160.265625 C 216.347656 153.394531 214.160156 147.769531 209.847656 143.550781 C 201.445312 135.324219 188.019531 135.539062 187.550781 135.53125 C 186.988281 135.527344 173.550781 135.363281 165.152344 143.601562 C 160.855469 147.816406 158.675781 153.421875 158.675781 160.265625 L 158.675781 161.339844 C 155.421875 162.394531 153.066406 165.445312 153.066406 169.050781 L 153.066406 176.839844 C 153.066406 181.320312 156.699219 184.949219 161.171875 184.949219 Z M 161.171875 184.949219 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
function SvgIcono4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono4);
export default __webpack_public_path__ + "static/media/icono4.a9e296f838ee3a0f5839cadef56fb70f.svg";
export { ForwardRef as ReactComponent };